import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import AdminDashboard from "./components/AdminDashboard";
import OurStory from "./components/OurStory";
import ThankYou from "./components/ThankYou";
import WaitlistModal from "./components/WaitlistModal";
import { WaitlistProvider } from "./context/WaitlistContext";
import "./App.css";

function App() {
  return (
    <WaitlistProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/thankyou" element={<ThankYou />} />
        </Routes>
        <WaitlistModal />
      </BrowserRouter>
    </WaitlistProvider>
  );
}

export default App;
